export enum ChatPanelForms {
  LanguageCustomizationPageForm = 'ChatCsatLanguageCustomizationPageForm',
  GlobalSettingsForm = 'ChatCsatGlobalSettingsForm',
}
